module.exports = __webpack_public_path__ + "05_long_black.a842b52c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/05_long_black.png
// module id = NKbU
// module chunks = 0